<template>
  <div class="total">
    <div class="item" v-for="item in dataList">
      <img :src="item.icon" alt="" />
      <p class="count">{{ item.count }}</p>
      <p class="title">{{ item.title }}</p>
    </div>
  </div>
</template>
<script>
import * as utils from "../utils";
import api from "../api";
export default {
  data() {
    return {
      dataList: [
        {
          icon: require("../../static/assets/lxzs.png"),
          title: "来信总数",
          count: 0,
          url: "",
        },
        {
          icon: require("../../static/assets/jrlx.png"),
          title: "今日来信",
          count: 0,
          url: "",
        },
        {
          icon: require("../../static/assets/hfzs.png"),
          title: "回复总数",
          count: 0,
          url: "",
        },
        {
          icon: require("../../static/assets/jrhf.png"),
          title: "今日回复",
          count: 0,
          url: "",
        },
      ],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      utils.Get(api.getLetterCount).then(res=>{
        let resp = JSON.parse(res.data);
        let datas = resp.datas[0];
        this.dataList[0].count = datas.allLetterCount;
        this.dataList[1].count = datas.todayLetterCount;
        this.dataList[2].count = datas.allReplyCount;
        this.dataList[3].count = datas.todayReplyCount
      })
    }
  }
};
</script>
<style scoped>
.total {
  background: rgba(233, 240, 255, 1);
  border: 0.06rem solid #f0f0f0;
  border-radius: 0.25rem;
  width: calc(100% - 4rem);
  padding: 1.5rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.25rem;
}

.item {
  text-align: center;
}

.item img {
  width: 2.19rem;
  height: 2.19rem;
  margin-bottom: 0.25rem;
}

.count {
  font-size: 1.5rem;
  color: #0f295f;
  font-weight: 700;
  margin-bottom: 0.25rem;
}

.title {
  font-size: 0.88rem;
  color: #434343;
  font-weight: 400;
}
</style>


// WEBPACK FOOTER //
// total.vue?1dd84558